import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import RegisterPage from "./auth/RegisterPage";
import LoginPage from "./pages/LoginPage";
import VerifyEmailPage from "./auth/VerifyEmailPage";
import PasswordResetPage from "./auth/PasswordResetPage";
import TwoFactorPage from "./auth/TwoFactorPage";

import Dashboard from "./components/Dashboard/Dashboard";
import PrivateRoute from "./auth/PrivateRoute"; // new file

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/reset-password" element={<PasswordResetPage />} />
        <Route path="/two-factor" element={<TwoFactorPage />} />
		<Route path="/login" element={<LoginPage />} />
        {/* Protected */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        {/* Default */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
